module.exports = __webpack_public_path__ + "dash_20_app_assets/img/avatar-s-14.c352e978.jpg";